var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container-carousel-full"},[_c('slider',{attrs:{"photosNumber":_vm.numberPhotos,"labelImageToShow":_vm.labelImageToShow}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }